/**
 * 表示されたらフェードイン
 */
const targets = document.querySelectorAll('.inview');

// 要素があるときだけ処理を実行
if (targets.length) {
    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                    obs.unobserve(entry.target);
                }
            });
        },
        {
            threshold: 0,
            rootMargin: '0px 0px -30% 0px'
        }
    );

    targets.forEach((el) => observer.observe(el));
}